import organization from './organization/ja'
import themeSceneExport from './themeSceneExport/ja'

export default {
    route: {
        Dashboard: 'Dashiban',
        rt_tt_DMSystem: '管理系统',
        rt_tt_MbManage: '主板管理',
        rt_tt_MbControlNew: '(新)PC端场控',
        rt_tt_MbInfo: '主板信息',
        rt_tt_MbRunRecord: '运行记录',
        rt_tt_ThemeEdit: '主题编辑',
        rt_tt_ThmSceneEdit: '场景编辑',
        rt_tt_ThmDevEdit: '设备编辑',
        rt_tt_ThmTaskEdit: '任务编辑',
        rt_tt_SystemSetting: '系统设置',
        rt_tt_SystemManage: '系统管理',
        rt_tt_UserManage: '用户管理',
        rt_tt_DevManage: '设备管理',
        rt_org_management: '組織管理',
        rt_org_access: '組織権限',
        rt_org_users: '組織メンバー',
        rt_role_permissions: 'ロールと権限',
        rt_device_resources: 'デバイスリソース',
        rt_my_boards: 'マイメインボード',
        rt_org_boards: '組織デバイス',
        rt_platform_boards: 'プラットフォームデバイス運用',
        rt_org_themes: '組織テーマ',
    },
    page: {
        p99_nav_home : '回首页',
        p99_nav_sivatech : '西瓦科技',
        p99_nav_logout : '退出登陆',


        p1_dsh_mb_info : '主板信息',
        p1_dsh_thm_edit : '主题编辑',
        p1_dsh_sys_setting : '系统设置',
        p1_dsh_pc_rt_ctl_new : 'PC端场控',
        p1_dsh_pc_rt_ctl : 'PC场控',
        p1_dsh_online : '在线',
        p1_dsh_tbshop : '在线商城',
        p1_dsh_help : '知识库',

        p2_rt2024_lbl_ipt_keyword : 'ボードまたはテーマ名を入力',
        p2_rt2024_lbl_live_only : 'オンラインのみ',
        p2_rt2024_show_more : '選択するとボードの詳細情報を表示します',
        p2_rt2024_lbl_wide : 'ワイド表示',
        p2_rt2024_lbl_idle : 'アイドル',
        p2_rt2024_lbl_ready : '準備完了',
        p2_rt2024_lbl_running : '実行中',
        p2_rt2024_lbl_finished : '終了',
        p2_rt2024_lbl_offline : 'オフライン',
        p2_rt2024_lbl_theme : 'テーマ： ',
        p2_rt2024_lbl_boot_theme_no_sel : 'スタートアップテーマ未選択',
        p2_rt2024_lbl_theme_mgr : 'テーマ管理',
        p2_rt2024_lbl_no_running_theme : 'ボードに実行中のテーマがありません',
        p2_rt2024_lbl_running_theme : '実行中のテーマ',
        p2_rt2024_lbl_sel_theme : 'テーマを選択してください',
        p2_rt2024_lbl_boot_theme : 'スタートアップテーマ',
        p2_rt2024_btn_exec_theme : 'テーマを実行',
        p2_rt2024_btn_set_boot_theme : 'スタートアップテーマを設定',
        p2_rt2024_msg_please_sel : '選択してください',
        p2_rt2024_msg_sel_correct_theme : '正しいテーマを選択してください',
        p2_rt2024_msg_setting : '設定中...',
        p2_rt2024_msg_boot_theme_ok : 'スタートアップテーマの設定に成功しました',
        p2_rt2024_msg_boot_theme_confirm_fail : 'コントローラーがスタートアップテーマを確認できませんでした。しばらくしてから再試行してください。',
        p2_rt2024_msg_theme_switching : 'テーマが切り替えられました、テーマ内容を読み込み中...',
        p2_rt2024_msg_scene_sync_retry : 'シーンデータの同期に失敗しました。再試行しています...',
        p2_rt2024_msg_scene_sync_fail : 'シーンデータの同期に失敗しました。ネットワークを確認してからテーマに入り直してください',
        p2_rt2024_lbl_api_latency : 'API遅延',
        p2_rt2024_lbl_api_latency_fail : '失敗',
        p2_rt2024_lbl_api_latency_scene_info : '現在のテーマ情報',
        p2_rt2024_lbl_api_latency_theme_list : 'テーマ一覧',
        p2_rt2024_lbl_api_latency_board_info : 'ボード情報',
        p2_rt2024_lbl_api_latency_res_config : 'リソース設定',
        p2_rt2024_lbl_api_latency_int_param : '実行パラメータ',
        p2_rt2024_lbl_api_latency_subdev_info : 'デバイス情報',
        p2_rt2024_lbl_dev_type : 'デバイス類型',
        p2_rt2024_lbl_board_type_main : 'クラウドコントローラー',
        p2_rt2024_lbl_board_type_plus : 'クラウドコントローラー Plus',
        p2_rt2024_lbl_board_type_nio : 'ネットワークポートコントローラー',
        p2_rt2024_lbl_board_type_na : 'ネットワークオーディオコントローラー',
        p2_rt2024_lbl_dev_offline : 'オフライン',
        p2_rt2024_lbl_dev_online : 'オンライン',
        p2_rt2024_lbl_net_dev : 'ネットワークデバイス',
        p2_rt2024_lbl_lang_default : 'デフォルト',
        p2_rt2024_lbl_lang_chi : '中国語(chi)',
        p2_rt2024_lbl_lang_eng : '英語(eng)',
        p2_rt2024_lbl_lang_jpn : '日本語(jpn)',
        p2_rt2024_lbl_lang_kor : '韓国語(kor)',
        p2_rt2024_lbl_run_limit_prefix : '実行可能期限: ',
        p2_rt2024_lbl_loading : 'データ読み込み中',
        p2_rt2024_msg_task_skip_ok : 'タスクスキップ成功',
        p2_rt2024_msg_task_skip_fail : 'タスクスキップ失敗',
        p2_rt2024_msg_skip_ok : 'スキップ成功',
        p2_rt2024_msg_scene_jump_ok : 'シーンジャンプ成功',
        p2_rt2024_msg_scene_jump_fail : 'シーンジャンプ失敗',
        p2_rt2024_msg_scene_trig_ok : 'シーン効果トリガー成功',
        p2_rt2024_msg_scene_trig_fail : 'シーン効果トリガー失敗',
        p2_rt2024_msg_task_op_ok : 'タスク制御成功',
        p2_rt2024_msg_task_op_fail : 'タスク制御失敗',
        p2_rt2024_msg_operate_ok : '操作成功',
        p2_rt2024_msg_operate_fail : '操作失敗',
        p2_rt2024_msg_reboot_ok : 'デバイス再起動成功',

        p2_rt2024_btn_ok : 'OK',
        p2_rt2024_btn_cancel : 'キャンセル',
        p2_rt2024_cfm_reboot : '再起動しますか？',
        p2_rt2024_btn_reboot : '再起動',
        p2_rt2024_lbl_show_act_t : 'アクティブなタスクのみ表示',
        p2_rt2024_lbl_refresh : '更新',
        p2_rt2024_lbl_theme_flow : 'テーマフロー',
        p2_rt2024_lbl_ipt_dev_name : 'デバイス名を入力',
        p2_rt2024_lbl_show_finished : '完了済みを表示',
        p2_rt2024_cfm_skip : 'スキップしますか？',
        p2_rt2024_btn_skip : 'スキップ',
        p2_rt2024_dev_operate : 'デバイス操作',
        p2_rt2024_lbl_number : '番号',
        p2_rt2024_lbl_port : 'ポート',
        p2_rt2024_lbl_none : 'なし',
        p2_rt2024_lbl_name : '名称',
        p2_rt2024_lbl_status : '状態',
        p2_rt2024_lbl_operate : '操作',
        p2_rt2024_lbl_fuzzy_query : 'キーワードで検索',
        p2_rt2024_lbl_effect_trig : 'エフェクトトリガー',
        p2_rt2024_lbl_trigger : 'トリガー',
        p2_rt2024_lbl_process_test : 'プロセステスト',
        p2_rt2024_lbl_port_info : 'ポート情報',
        p2_rt2024_lbl_board_setting : 'ボード設定',
        p2_rt2024_lbl_loading : '読み込み中',


        p2_2_rt_c_bpV5_ip : '入力ポート',
        p2_2_rt_c_bpV5_ipb : '入力ポートボード',
        p2_2_rt_c_bpV5_op : '出力ポート',
        p2_2_rt_c_bpV5_opb : '出力ポートボード',

        p2_3_rt_c_bs_cfgdata : '設定データ',
        p2_3_rt_c_bs_pctn : '購入済みタスク数',
        p2_3_rt_c_bs_actn : '同時実行タスク数',
        p2_3_rt_c_bs_pr_cnt : '購入済みセッション数',
        p2_3_rt_c_bs_ur_cnt : '実行済みセッション数',
        p2_3_rt_c_bs_hw_ver : 'ハードウェアバージョン',
        p2_3_rt_c_bs_sw_ver : 'ファームウェアバージョン',
        p2_3_rt_c_bs_btn_okay : 'OK',
        p2_3_rt_c_bs_btn_cancel : 'キャンセル',
        p2_3_rt_c_bs_confirm_upd : 'アップグレードしますか？',
        p2_3_rt_c_bs_do_upd : 'アップグレード',
        p2_3_rt_c_bs_more : '詳細設定',
        p2_3_rt_c_bs_cfg_addr : '設定アドレス',
        p2_3_rt_c_bs_pls_input : '入力してください',
        p2_3_rt_c_bs_addr_modify : 'アドレスを変更',
        p2_3_rt_c_bs_thm_update : 'テーマをアップグレード',
        p2_3_rt_c_bs_fw_addr : 'ファームウェアアドレス',
        p2_3_rt_c_bs_fw_addr_pls_input : 'ファームウェアアドレスを入力してください',
        p2_3_rt_c_bs_fw_addr_invalid : 'ファームウェアアドレスは115文字以内で、1バイト文字のみ使用できます',
        p2_3_rt_c_bs_fw_update : 'ファームウェアをアップグレード',
        p2_3_rt_c_bs_resource : 'リソース',
        p2_3_rt_c_bs_vid_mode : 'ビデオモード',
        p2_3_rt_c_bs_v_cont_ud_str : 'ファイルはセットトップボックスの USB にあります',
        p2_3_rt_c_bs_local : 'ローカル',
        p2_3_rt_c_bs_v_cont_inet_str : 'ファイルはインターネットサーバーにあります（公衆ネットワーク接続が必要で低速です）',
        p2_3_rt_c_bs_v_cont_lan_str : 'ファイルは店舗サーバーにあります（高速）',
        p2_3_rt_c_bs_svr_lan_url : 'サーバー（LAN IP）',
        p2_3_rt_c_bs_aud_mode : 'オーディオモード',
        p2_3_rt_c_bs_a_cont_ud_str : 'ファイルはボードの TF カードまたは USB にあります',
        p2_3_rt_c_bs_btn_save : '保存',
        p2_3_rt_c_bs_svr_url : 'サーバー URL',
        p2_3_rt_c_bs_pls_input_svr_url : 'サーバーアドレスを入力',
        p2_3_rt_c_bs_svr_lan_ip : 'サーバー IP アドレス',
        p2_3_rt_c_bs_ipt_svr_ip : 'IP アドレスを入力',
        p2_3_rt_c_bs_svr_port : 'サーバーポート',
        p2_3_rt_c_bs_aud_stb_id : 'オーディオセットトップボックス ID',
        p2_3_rt_c_bs_param_cfg : 'パラメータ設定',
        p2_3_rt_c_bs_detail_rtinfo : '詳細な実行情報',
        p2_3_rt_c_bs_run_mode : '実行モード',
        p2_3_rt_c_bs_port_mode : 'ポートスケジュールモード',
        p2_3_rt_c_bs_net_dev_man : 'ネットワークデバイス管理',
        p2_3_rt_c_bs_net_reconn : 'ネットワーク再接続',
        p2_3_rt_c_bs_nio_feature : 'ネットワークポート機能',
        p2_3_rt_c_bs_btn_update : '更新',
        p2_3_rt_c_bs_lbl_unlimit : '無制限',
        p2_3_rt_c_bs_lbl_unknown : '未集計',
        p2_3_rt_c_bs_lbl_bootcnt : '起動回数',
        p2_3_rt_c_bs_lbl_lang : '言語',
        p2_3_rt_c_bs_lbl_res_code : 'リソースコード',
        p2_3_rt_c_bs_lbl_dev_id : 'デバイスID',
        p2_3_rt_c_bs_lbl_play_mode : '再生モード',
        p2_3_rt_c_bs_lbl_sel_play_mode : '再生モードを選択してください',
        p2_3_rt_c_bs_lbl_def_vol : 'デフォルト音量',
        p2_3_rt_c_bs_lbl_ext_amp : '外部パワー 앰프',
        p2_3_rt_c_bs_lbl_switch_on : 'オン',
        p2_3_rt_c_bs_lbl_switch_off : 'オフ',
        p2_3_rt_c_bs_lbl_audio_ctrl : 'オーディオ制御',
        p2_3_rt_c_bs_lbl_port_limit : 'ポート上限設定',
        p2_3_rt_c_bs_lbl_limit : '制限',
        p2_3_rt_c_bs_lbl_no_limit : '無制限',
        p2_3_rt_c_bs_lbl_sel_date : '日付と時間を選択',
        p2_3_rt_c_bs_lbl_single_stop : '1曲停止',
        p2_3_rt_c_bs_lbl_single_loop : '1曲ループ',
        p2_3_rt_c_bs_label_debug : 'デバッグ情報レベル',
        p2_3_rt_c_bs_cloud_server : 'クラウドサーバー',
        p2_3_rt_c_bs_admin_param : '管理者パラメータ',
        p2_3_rt_c_bs_run_limit : '実行時間制限',
        p2_3_rt_c_bs_msg_fw_done : 'アップグレード完了',
        p2_3_rt_c_bs_msg_fw_start : 'アップグレード開始',
        p2_3_rt_c_bs_msg_fw_fail : 'アップグレード失敗',
        p2_3_rt_c_bs_msg_thm_done : 'テーマアップグレード完了',
        p2_3_rt_c_bs_msg_thm_timeout : 'テーマアップグレードタイムアウト',
        p2_3_rt_c_bs_msg_thm_start : 'テーマ更新開始',
        p2_3_rt_c_bs_msg_cfg_ok : '設定が正常に変更されました',
        p2_3_rt_c_bs_msg_cfg1_ok : '設定1が正常に変更されました',
        p2_3_rt_c_bs_msg_cfg2_ok : '設定2が正常に変更されました',
        p2_5_rt_c_bw_lbl_cloud_days : 'クラウドコントロール可能日数',
        p2_5_rt_c_bw_lbl_contact_svc : '有効期限が切れている場合はカスタマーサービスまでご連絡ください',
        p2_5_rt_c_bw_lbl_infinite : '無制限',
        p2_5_rt_c_bw_lbl_expired : '期限切れ',
        p2_5_rt_c_bw_lbl_days : '日',
        p2_5_rt_c_bw_msg_skip_ok : 'スキップ成功',
        p2_6_rt_c_tsk_c_lbl_scene_skip_title : 'ジャンプ先のシーンを選択してください',
        p2_6_rt_c_tsk_c_btn_close : '閉じる',
        p2_6_rt_c_tsk_c_btn_confirm : '確認',
        p2_6_rt_c_tsk_c_lbl_assign : '割り当て',
        p2_6_rt_c_tsk_c_lbl_become : '変化',
        bit_edit_lbl_current_val : '現在値',
        bit_edit_lbl_input_hint : '整数を入力（0x 十六進数をサポート）：',
        bit_edit_lbl_decimal_val : '数値（十進数）：',
        bit_edit_lbl_hex_val : '数値（十六進数）：',
        bit_edit_lbl_readonly : '読み取り専用',
        bit_edit_lbl_bit : 'ビット',
        bit_edit_lbl_bits : 'ビットフィールド',
        bit_edit_lbl_hex : '16進数',
        bit_edit_lbl_dec : '10進数',
        extra_param_desc_debug_level : 'デバッグ情報レベル（0-F、1-E、2-E、3-I、4-V）',
        extra_param_desc_serial_print : 'シリアル出力を有効化',
        extra_param_desc_action_log_suppression : '実行中の動作ログを抑制',
        extra_param_desc_disable_network_log : 'ネットワークログを無効化',
        extra_param_desc_task_end_mode : 'タスク終了モード',
        extra_param_desc_skip_mode : 'スキップモード',
        extra_param_desc_stop_same_port_output : '同じポートの出力デバイスを停止',
        extra_param_desc_ms_unit : 'ミリ秒単位',
        extra_param_desc_multi_card_ic_timing : 'マルチカード IC（0）2ms/（1）4ms',
        extra_param_desc_remote_control_timing : 'リモコン（0）8ms/（1）4ms',
        extra_param_desc_multi_card_gap : 'マルチカードで GAP を使用',
        extra_param_desc_nio_input_change_log : 'NIO 入力ポートの変更を記録',
        extra_param_desc_input_port_ll : '入力ポート LL',
        extra_param_desc_output_port_ll : '出力ポート LL',
        extra_param_desc_volume_control : '音量制御',
        extra_param_desc_timer_volume_control : 'タイマー方式で音量制御を送信',
        extra_param_desc_reconnect_count : '切断後の再接続回数',
        extra_param_desc_network_discovery_timeout : 'ネットワークデバイス検出タイムアウト',
        extra_param_desc_sockcomm_no_check : 'sockcomm 応答を検証しない',
        extra_param_desc_udp_token_check : 'ネットワークポートボードの UDP Token を検証',
        extra_param_desc_udp_sequence_check : 'ネットワークポートボードの UDP シーケンス番号を検証',
        extra_param_desc_http_download_optimization : 'HTTP ダウンロードを最適化',
        extra_param_desc_networkctrl_tcp_async_send : 'networkctrl TCP 非同期送信',
        extra_param_desc_mobile_network_optimization : 'モバイルネットワークを最適化',
        extra_param_desc_networkctrl_tcp_async_drop : 'networkctrl TCP 非同期 DROP をサポート',
        extra_param_desc_input_port_status_log : 'Input パケットのポート状態変更を記録',
        extra_param_desc_retransmission : '再送メカニズム',
        extra_param_desc_extradata_crc_check : 'ExtraData CRC 検証',
        extra_param_desc_input_module_limit : '入力モジュール上限（0 = 無制限）',
        extra_param_desc_output_module_limit : '出力モジュール上限（0 = 無制限）',
        extra_param_desc_cloud_server : 'クラウドサーバー接続の選択（0～2）',


        p2_4_rt_c_b5_rbt_board : 'ボードを再起動',
        p2_4_rt_c_b5_btn_ok : 'OK',
        p2_4_rt_c_b5_btn_cancel : 'キャンセル',
        p2_4_rt_c_b5_cfm_reboot : '再起動しますか？',
        p2_4_rt_c_b5_lbl_idle : 'アイドル',
        p2_4_rt_c_b5_lbl_ready : '準備完了',
        p2_4_rt_c_b5_lbl_running : '実行中',
        p2_4_rt_c_b5_lbl_finished : '終了',
        p2_4_rt_c_b5_lbl_offline : 'オフライン',
        p2_4_rt_c_b5_lbl_time : '使用時間',
        p2_4_rt_c_b5_lbl_detail : '詳細',
        p2_4_rt_c_b5_lbl_inf : '無期限',
        p2_4_rt_c_b5_lbl_outdated : '期限切れ',
        p2_4_rt_c_b5_lbl_day : '日',
        p2_4_rt_c_b5_msg_v_days : 'クラウド制御可能日数：',
        p2_4_rt_c_b5_msg_contact : '期限切れの場合はカスタマーサービスにお問い合わせください。',

        p2_5_rt_c_bw_btn_ok : 'OK',
        p2_5_rt_c_bw_btn_cancel : 'キャンセル',
        p2_5_rt_c_bw_cfm_reboot : '再起動しますか？',
        p2_5_rt_c_bw_cfm_skip : 'メインタスクをスキップしますか？',
        p2_5_rt_c_bw_lbl_time : '使用時間',
        p2_5_rt_c_bw_scene_skip : 'スキップ',
        p2_5_rt_c_bw_lbl_detail : '詳細',

        p2_6_rt_c_tsk_c_lbl_task : 'タスク',
        p2_6_rt_c_tsk_c_lbl_show_finish : '完了済みを表示',
        p2_6_rt_c_tsk_c_btn_ok : 'OK',
        p2_6_rt_c_tsk_c_btn_cancel : 'キャンセル',
        p2_6_rt_c_tsk_c_cfm_skip : 'スキップしますか？',
        p2_6_rt_c_tsk_c_btn_skip : '次へスキップ',
        p2_6_rt_c_tsk_c_msg_skip_ok : 'タスクのスキップに成功しました',
        p2_6_rt_c_tsk_c_msg_skip_fail : 'タスクのスキップに失敗しました',
        p2_6_rt_c_tsk_c_msg_op_success : 'タスク操作に成功しました',
        p2_6_rt_c_tsk_c_msg_op_fail : 'タスク操作に失敗しました',
        p2_6_rt_c_tsk_c_msg_scene_lst : 'シーンを選択',
        p2_6_rt_c_tsk_c_msg_scene_skip_cfm : 'シーンへスキップしますか？',

        p3_te_ztbj_theme_name : '主题名称',
        p3_te_ztbj_fuzzy_query : '支持关键字模糊查询',
        p3_te_ztbj_query : '查询',
        p3_te_ztbj_new : '新建',
        p3_te_ztbj_ide_config : 'IDE 配置',
        p3_te_ztbj_show_number : '显示序号',
        p3_te_ztbj_shs_ipt_list : '勾选显示动作条内部序号',
        p3_te_ztbj_auto_name : '自动名称',
        p3_te_ztbj_show_auto_name : '勾选后，动作名称自动添加端口号',
        p3_te_ztbj_lbl_done : '完 成',
        p3_te_ztbj_lbl_edit : '編集',
        p3_te_ztbj_lbl_name : '名称',
        p3_te_ztbj_lbl_description : '描述',
        p3_te_ztbj_resrouce_code : '资源代码',
        p3_te_ztbj_btn_cancel : '取消',
        p3_te_ztbj_confirm : '確定',
        p3_te_ztbj_btn_share : '分享',
        p3_te_ztbj_pls_ipt_phone : '请输入手机号',
        p3_te_ztbj_find : '查找',
        p3_te_ztbj_btn_backup : '备份',
        p3_te_ztbj_btn_del : '削除',
        p3_te_ztbj_btn_cooperate : '协作',
        p3_te_ztbj_choose_date : '选择日期',
        p3_te_ztbj_own_theme : '自有主题',
        p3_te_ztbj_coop_theme : '协作主题',
        p3_te_ztbj_invalid_phone_num : '手机号不正确',
        p3_te_ztbj_usr_n_found : '未找到用户',
        p3_te_ztbj_inv_param : '参数不完整或不正确',
        p3_te_ztbj_msg_share_success : '分享成功',
        p3_te_ztbj_msg_share_failed : '分享失败',
        p3_te_ztbj_coop_success : '协作成功',
        p3_te_ztbj_coop_fail : '协作失败',
        p3_te_ztbj_bk_theme_prompt : '备份当前主题？',
        p3_te_ztbj_prompt : '確認',
        p3_te_ztbj_bk_success : '备份成功，请更新主题备注信息',
        p3_te_ztbj_bk_failed : '备份失败',
        p3_te_ztbj_cfm_del : '确认删除选中主题吗？',
        p3_te_ztbj_del_success : '删除主题成功',
        p3_te_ztbj_dev_fail : '删除主题失败',
        p3_te_ztbj_create_success : '新增主题成功',
        p3_te_ztbj_mdf_t_info_success : '修改主题基本信息成功',
        p3_te_ztbj_mdf_t_info_fail : '修改主题基本信息失败',
        p3_te_ztbj_dev_prop_empty : '有设备的属性为空,请选填',
        p3_te_ztbj_upd_confirm : '升级主题配置到最新，以获得更多玩法和功能？建议先进行一次备份',
        p3_te_ztbj_chkbar_actbar_empty : '有checkBar或actionBar为空,请先选填',
        p3_te_ztbj_thm_upd_success : '升级配置成功',
        p3_te_ztbj_read_only : '只读',
        p3_te_ztbj_lbl_owner : '所有者',
        p3_te_ztbj_lbl_mod_time : '修改时间',
        p3_te_ztbj_lbl_modify : '修改',
        p3_te_ztbj_lbl_dev_edit : '设备编辑',
        p3_te_ztbj_lbl_thm_edit : '场景编辑',
        p3_te_ztbj_lbl_task_edit : '任务编辑',
        p3_te_ztbj_lbl_upd_cfg : '升级配置',
        p3_te_ztbj_lbl_mgn : '管理',
        p3_te_ztbj_lbl_ver : '版本',

        p4_lgn_tt_siva_cloud : '西瓦科技实景娱乐管理系统',
        p4_lgn_tt_pwd_lgn : '密码登录',
        p4_lgn_tt_username : '用户名',
        p4_lgn_tt_passowrd : '密码',
        p4_lgn_tt_login : '登陆',
        p4_lgn_tt_sms_lgn : '短信登录',
        p4_lgn_tt_phone : '手机号',
        p4_lgn_cap_pwd_lgn : '验证码',
        p4_lgn_tt_sec_to : '秒后获取验证码',
        p4_lgn_tt_veri_code : '获取验证码',

        p5_te_dev_lbl_thm_name : '主题名称',
        p5_te_dev_lbl_add : '增加',
        p5_te_dev_lbl_finish : '完 成',
        p5_te_dev_tt_iogrp_edit : '端口组编辑',
        p5_te_dev_lbl_name : '名称',
        p5_te_dev_lbl_work_mode : '動作モード',
        p5_te_dev_lbl_pls_choose : '選択してください',
        p5_te_dev_lbl_edit : '编辑',
        p5_te_dev_tt_ipt_edit : '输入端口编辑',
        p5_te_dev_lbl_sec : '秒',
        p5_te_dev_tt_opt_edit : '输出端口编辑',
        p5_te_dev_lbl_ms : '毫秒',
        p5_te_dev_lbl_down_2_brd : '下发配置',
        p5_te_dev_btn_save : '保存',
        p5_te_dev_btn_push : '下发',
        p5_te_dev_lbl_cfm_push_theme : '确定下发主题',
        p5_te_dev_lbl_2_board : '到主板',
        p5_te_dev_btn_cancel : 'キャンセル',
        p5_te_dev_btn_confirm : '確定',
        p5_te_dev_lbl_thm_id : '主题ID',
        p5_te_dev_lbl_res_code : '资源代码',
        p5_te_dev_lbl_svr_mode : '(用于服务器方式播放音视频)',
        p5_te_dev_lbl_note : '备注',
        p5_te_dev_btn_theme_list : '基本信息',
        p5_te_dev_btn_scene_edit : '场景编辑',
        p5_te_dev_tt_dev_order_set : '设备顺序设置',
        p5_te_dev_btn_new_dev : 'デバイスを追加',
        p5_te_dev_btn_help : '帮助',
        p5_te_dev_btn_order : '排序',
        p5_te_dev_btn_export : '设备导出',
        p5_te_dev_lbl_loading : '加载中',
        p5_te_dev_lbl_number : '序号',
        p5_te_dev_lbl_name : '名称',
        p5_te_dev_lbl_dev_edit : '设备编辑',
        p5_te_dev_tt_base_info : '基础信息',
        p5_te_dev_lbl_note : '说明',
        p5_te_dev_tt_cfg_info : '配置信息',
        p5_te_dev_tt_dev_export : '设备信息导出',
        p5_te_dev_lbl_category : '类型',
        p5_te_dev_lbl_netdev : '网络设备',
        p5_te_dev_lbl_port_no : '端口',
        p5_te_dev_lbl_input_port_output : '入力ポートから出力',
        p5_te_dev_hint_input_port_output : '入力ポートの順序に従い、各番号に 1024 を加えて出力ポートを自動生成します',
        p5_te_dev_lbl_open_port : '开端口',
        p5_te_dev_lbl_close_port : '关端口',
        p5_te_dev_lbl_file_no : '文件序号',
        p5_te_dev_tt_cfm_push : '配信確認',
        p5_te_dev_lbl_pls_enter : '入力してください',
        p5_te_dev_lbl_ro : '読み取り専用',
        p5_te_dev_btn_do_export : 'エクスポート',
        p5_te_dev_lbl_pls_sel_bd : '主板を選択してください',
        p5_te_dev_msg_ro_no_saving : '読み取り専用モードのため、保存せずに移動します',
        p5_te_dev_msg_empty_condition_err : '現在のシーンに空の条件欄または動作欄があります。入力するか削除してください',
        p5_te_dev_msg_auto_save_ok : '自動保存に成功しました',
        p5_te_dev_msg_auto_save_fail : '自動保存に失敗しました',
        p5_te_dev_msg_brd_lst_refresh : '主板リストを更新しました',
        p5_te_dev_msg_fail_obt_blist : '主板リストの取得に失敗しました',
        p5_te_dev_lbl_pinyin_search : '支持拼音查询',
        p5_te_dev_lbl_total : '共',
        p5_te_dev_lbl_devices : '个设备',
        p5_te_dev_msg_port_limit : '增加：数量已达上限',
        p5_te_dev_msg_dup_netdev_id : '网络设备ID有重复',
        p5_te_dev_msg_issue_auth_expired : '下发失败: 云平台权限已过期',
        p5_te_dev_msg_issue_started : '开始下载配置',
        p5_te_dev_msg_issue_fail : '下发失败:',
        p5_te_dev_cfm_del_sel_dev : '選択したデバイスを削除しますか？',
        p5_te_dev_msg_del_dev_success : 'デバイスを削除しました',
        p5_te_dev_msg_del_dev_used : 'シーン編集で使用中のため、このデバイスは削除できません',
        p5_te_dev_msg_del_dev_fail : 'デバイスの削除に失敗しました',
        p5_te_dev_lbl_device_manager : 'デバイス管理',
        p5_te_dev_lbl_device_summary : '設定概要',

        // ===== p8: システム設定 xtsz =====
        p8_xtsz_title : 'システム設定',
        p8_xtsz_lbl_nickname : 'ニックネーム',
        p8_xtsz_lbl_login_name : 'ログイン名',
        p8_xtsz_lbl_phone : '電話番号',
        p8_xtsz_lbl_board_name : '主板名',
        p8_xtsz_lbl_show_limit : '回数制限',
        p8_xtsz_lbl_search_name : '名前検索',
        p8_xtsz_lbl_own_board : '自有主板',
        p8_xtsz_lbl_shared_board : '共有给我的主板',
        p8_xtsz_lbl_logged_client : 'ログイン済みクライアント',
        p8_xtsz_btn_edit : '編集',
        p8_xtsz_btn_search : '検索',
        p8_xtsz_btn_share : '共有',
        p8_xtsz_btn_rename : '改名',
        p8_xtsz_btn_transfer : '移行',
        p8_xtsz_btn_delete : '削除',
        p8_xtsz_btn_cancel : 'キャンセル',
        p8_xtsz_btn_confirm : 'OK',
        p8_xtsz_btn_logout : 'ログアウト',
        p8_xtsz_dlg_user_info : 'ユーザー情報',
        p8_xtsz_dlg_login_pwd : 'ログインパスワード',
        p8_xtsz_dlg_repeat_pwd : 'パスワード確認',
        p8_xtsz_dlg_board_transfer : '主板移行',
        p8_xtsz_dlg_set_share : '共有設定',
        p8_xtsz_dlg_delete_share : '共有削除',
        p8_xtsz_dlg_edit_board : '主控板修正',
        p8_xtsz_dlg_board_limit : '主板回数制限',
        p8_xtsz_col_user : 'ユーザー',
        p8_xtsz_col_phone : '電話',
        p8_xtsz_col_validity : '有効期限',
        p8_xtsz_col_operation : '操作',
        p8_xtsz_col_name : '名称',
        p8_xtsz_col_uid : 'UID',
        p8_xtsz_col_firmware : 'ファームウェア',
        p8_xtsz_col_status : '状態',
        p8_xtsz_col_seq : '番号',
        p8_xtsz_col_login_time : 'ログイン時間',
        p8_xtsz_col_login_ip : 'ログインIP',
        p8_xtsz_col_client_info : 'クライアント情報',
        p8_xtsz_ph_area_code : 'エリアコード',
        p8_xtsz_ph_keyword_query : 'キーワード検索',
        p8_xtsz_ph_board_name : '主板名を入力',
        p8_xtsz_ph_show_limit_hint : '0 = 無制限',
        p8_xtsz_ph_phone_input : '電話番号を入力',
        p8_xtsz_empty_no_share : 'まだ共有されていません',
        p8_xtsz_empty_no_login : 'ログイン履歴なし',
        p8_xtsz_status_online : 'オンライン',
        p8_xtsz_status_offline : 'オフライン',
        p8_xtsz_warn_transfer : '移行成功后、現在のユーザーは操作できません。慎重に通じてください。',
        p8_xtsz_warn_delete_share : 'このユーザーの共有を削除しますか？',
        p8_xtsz_warn_share_limit : 'このデバイスはすでに10人以上のユーザーと共有されています。まず清理してください。',
        p8_xtsz_msg_no_transfer_user : '移行ユーザー未設定',
        p8_xtsz_msg_transfer_success : '主板移行成功',
        p8_xtsz_msg_operation_failed : '操作失敗',
        p8_xtsz_msg_board_edit_success : '主板修正成功',
        p8_xtsz_msg_limit_set_success : '回数制限設定成功',
        p8_xtsz_msg_pwd_mismatch : 'パスワードが一致しません',
        p8_xtsz_msg_user_update_success : 'ユーザー修正成功',
        p8_xtsz_msg_user_update_failed : 'ユーザー修正失敗',
        p8_xtsz_msg_phone_format_error : '電話番号フォーマットエラー',
        p8_xtsz_msg_user_not_found : 'ユーザーが見つかりません',
        p8_xtsz_lbl_user_prefix : 'ユーザー ',
        p8_xtsz_msg_no_share_user : '共有ユーザー未設定',
        p8_xtsz_msg_share_success : '共有成功',
        p8_xtsz_msg_share_cancel_success : '共有取消成功',
        p8_xtsz_msg_share_info_updated : '共有情報更新成功',
        p8_xtsz_msg_get_share_info_failed : '共有情報取得失敗',
        p8_xtsz_msg_token_remove_success : 'ユーザーセッション終了',
        p8_xtsz_msg_token_remove_failed : 'ユーザーセッション終了失敗',
        p8_xtsz_ph_phone_placeholder : '電話番号を入力',
        p6_te_scn_msg_manual_save_ok : '手動保存に成功しました',
        p6_te_scn_lbl_desc_txt : '説明文',
        p6_te_scn_lbl_and : 'かつ',
        p6_te_scn_lbl_or : 'または',
        p6_te_scn_lbl_add_au : 'アクション単位を追加',
        p6_te_scn_lbl_mod_au : 'アクション単位を編集',
        p6_te_scn_lbl_param : 'パラメーター',
        p6_te_scn_lbl_batch_add_au : 'アクションを一括追加',
        p6_te_scn_lbl_cp_al : 'アクションバーをコピー',
        p6_te_scn_lbl_dev_cate : 'デバイスカテゴリ',
        p6_te_scn_lbl_action : 'アクション',
        p6_te_scn_msg_pls_sel_a : 'アクションを選択してください',
        p6_te_scn_lbl_add_lu : 'ロジック単位を追加',
        p6_te_scn_lbl_mod_lu : 'ロジック単位を編集',
        p6_te_scn_lbl_remove : '削除',
        p6_te_scn_lbl_add_to : '追加',
        p6_te_scn_lbl_tbs : '使用可能',
        p6_te_scn_lbl_seled : '選択済み',
        p6_te_scn_lbl_batch_add : '一括追加',
        p6_te_scn_lbl_pls_chs_or_keywd : '選択またはキーワードを入力してください',
        p6_te_scn_lbl_selected : '選択済み',
        p6_te_scn_lbl_ports : 'ポート',
        p6_te_scn_lbl_clear : 'クリア',
        p6_te_scn_lbl_port_sel : 'ポートを選択',
        p6_te_scn_lbl_port_filter_placeholder : 'ポート番号または数字で絞り込み（例: 1）',
        p6_te_scn_lbl_sel_ports : '選択したポート',
        p6_te_scn_lbl_clear_2 : 'クリア',
        p6_te_scn_lbl_clear_all : 'すべてクリア',
        p6_te_scn_lbl_pls_sel_wm : '動作モードを選択してください',
        p6_te_scn_msg_edit_tag_pending : '編集中のアクションタグを先に完了してください',
        p6_te_scn_msg_dev_create_success : 'デバイスを追加しました',
        p6_te_scn_msg_device_not_found : 'デバイスが見つかりません',
        p6_te_scn_msg_scene_lst : 'シーン一覧',
        p6_te_scn_lbl_math_add : '加算',
        p6_te_scn_lbl_math_sub : '減算',
        p6_te_scn_lbl_math_mul : '乗算',
        p6_te_scn_lbl_math_div : '除算',
        p6_te_scn_btn_export : 'エクスポート',
        p6_te_scn_btn_export_xmind : 'マインドマップをエクスポート',
        p6_te_scn_msg_manual_save_fail : '手動保存に失敗しました',
        audio_beat_theme_edit: 'テーマ編集',
        audio_beat_scene_edit: 'シーン編集',
        audio_beat_title: 'オーディオビートポイント',
        audio_beat_current_scene: '現在のシーン',
        audio_beat_back_to_scene_edit: 'シーン編集に戻る',
        audio_beat_no_audio: 'オーディオ未選択',
        audio_beat_choose_audio: 'オーディオを選択',
        audio_beat_pause: '一時停止',
        audio_beat_play: '再生',
        audio_beat_back_to_start: '先頭に戻る',
        audio_beat_timeline: 'タイムライン',
        audio_beat_zoom_out: 'タイムラインを縮小',
        audio_beat_zoom_in: 'タイムラインを拡大',
        audio_beat_fit_timeline: '全体表示',
        audio_beat_reselect_audio: '再選択',
        audio_beat_timeline_heading: 'オーディオとクリアアクション',
        audio_beat_timeline_help: '空白部分をドラッグして移動し、アクションバーをドラッグして実行時間を調整します',
        audio_beat_undo_move: '移動を元に戻す',
        audio_beat_redo_move: '移動をやり直す',
        audio_beat_lock_action_drag: 'アクションバーのドラッグをロック',
        audio_beat_waveform: '波形',
        audio_beat_action_bars: 'クリアアクションバー',
        audio_beat_undo_this_move: '今回の移動を元に戻す',
        audio_beat_action_bar_count: 'アクションバー {count} 件 | アクションバー {count} 件',
        audio_beat_action_unit_count: 'アクション単位 {count} 件 | アクション単位 {count} 件',
        audio_beat_add_action_at_time: '現在時刻にアクションバーを追加',
        audio_beat_delete_action_bar: 'アクションバーを削除',
        audio_beat_no_action_bars: 'アクションバーなし',
        audio_beat_action_bar_edit: 'アクションバー編集',
        audio_beat_name: '名前',
        audio_beat_action_bar_name: 'アクションバー名',
        audio_beat_condition: '条件',
        audio_beat_check_action_help: 'CheckAction の実行条件を編集',
        audio_beat_add_condition_group: '条件グループを追加',
        audio_beat_edit_branch: '分岐を編集',
        audio_beat_action_units: 'アクション単位',
        audio_beat_action_unit_help: '従来のアクションバー編集と一括追加を使用します',
        audio_beat_select_action_bar: 'アクションバーを選択してください',
        audio_beat_new_action_hint: '新しい遅延時間: {time}。作成後、タイムラインにアクションバーが表示されます。',
        audio_beat_unconditional_action: '無条件アクションバー',
        audio_beat_conditional_action: '条件付きアクションバー',
        audio_beat_success: '成功',
        audio_beat_failure: '失敗',
        audio_beat_load_failed: '読み込み失敗',
        audio_beat_loaded: '読み込み済み',
        audio_beat_please_choose_audio: 'オーディオファイルを選択してください',
        audio_beat_saved_file_unreadable: 'ローカルに保存されたオーディオを読み込めません。もう一度選択してください。',
        audio_beat_saved_file_missing: 'オーディオファイル「{path}」の保存内容が見つかりません。もう一度選択してください。',
        audio_beat_local_save_failed: 'オーディオは使用できますが、ローカル保存に失敗しました。次回は再選択が必要です。',
        audio_beat_scene_id_missing: '現在のシーンに一意のIDがないため、次回オーディオを復元できません。',
        audio_beat_load_error: 'オーディオの読み込みに失敗しました。ファイルがないか、未対応または破損しています。再選択してください。',
        audio_beat_play_error: 'オーディオを再生できません。もう一度選択してください。',
        audio_beat_default_action_name: 'アクションバー {number}',
        audio_beat_action_bar: 'アクションバー',
        audio_beat_keep_one_condition_group: '条件グループを1つ以上残してください',
        audio_beat_action_limit: 'クリアアクションバー数が上限（{limit}件）を超えています。',
        audio_beat_move_time: '時間: {from} → {to}',
        audio_beat_select_scene_first: '先にシーンを選択してください',

        dh_dt_1_p12 : '失败时，自动播放的音效编号。0 不播放',
        dh_dt_1_p13 : '成功时，自动播放的音效编号。0 不播放',
        hc_dt_1 : '<h3>外部多按键模块、电话机，或主板的多个输入、输出端口</h3><br/>  <p><li>工作模式<ul><li>外部模块：需要配置信号1(DA)端口和信号2(CK)端口<br/>    <ul>      <li>信号1(DA)端口: 结果端口</li>      <li>信号2(CK)端口: 触发端口</li>    </ul>    </li><br/>  <li>顺序按键：按顺序添加(勾选)主板端口，当这些端口按顺序触发时，端口组产生正确信号</li></br>  <li>顺序输出：输出端口列表中，按顺序添加主板输出端口，这些端口会依次亮起<br/>    <ul>      <li>启动端口: 每个端口点亮的时间(1=0.1秒)</li>      <li>停止端口: 每个端口熄灭的时间(1=0.1秒)</li>      <li>信号1(DA)端口: 端口是否熄灭控制 0 熄灭，1 不熄灭</li>      <li>信号2(CK)端口: 循环控制 0 循环，1不循环</li>    </ul>    </li></br>  <li>输入并联：输出端口列表中，添加主板输入端口；当这些端口任一个被触发时，端口组产生正确信号</li></br>  <li>输入串联：输出端口列表中，添加主板输入端口；当这些端口任一个被触发时，端口组产生正确信号</li></br>  <li>无序按键：输出端口列表中，添加主板输入端口；当这些端口均被触发过后，端口组产生正确信号</li></br>  <li>循环按键：输出端口列表中，按顺序添加主板输入端口；当这些端口按顺序触发，端口组产生正确信号。不产生错误信号</li></br>  <li>按键计数：输出端口列表中，按顺序添加主板输入端口；输出端口列表中，填入每个端口应该按下的次数</br>    当这些端口按下指定次数后，端口组产生正确信号。</li></br>  <li>呼吸灯组：输出端口列表中，添加需要参与呼吸效果的端口；</br>    <ul>      <li>呼吸速度：呼吸的速度，值越大呼吸越慢</li>      <li>停在最亮、最暗的时间</li>      <li>最大亮度：灯的最大亮度，1-100</li>    </ul></li></br>  <li>多卡顺序识别：判定依次感应的IC卡编号，符合顺序的过关</br>    <ul>      <li>呼吸速度：呼吸的速度，值越大呼吸越慢</li>      <li>停在最亮、最暗的时间</li>      <li>答案列表：依次添加需要刷的卡号</li>    </ul>  </li></br>  </li></p>',
        hc_dt_10 : '<h3>背景音</h3><br/>  <span>背景音开始播放后进入循环播放模式，支持本地模式(U盘或TF卡)<br/>和网络模式(通过音效机顶盒)</span>  <p><li>文件编号<ul><li>音效对应的文件编号，文件在U盘或服务器上以编号.mp3命名。<br/>  如001.mp3,002.mp3</li><br/>  </li></p>  ',
        hc_dt_11 : '<h3>视频</h3><br/>  <span>视频支持本地模式(播放位于机顶盒上的U盘中的视频文件)<br/>  和网络模式(播放门店服务器中的视频文件)</span>    <li>文件编号: 本地模式下，在U盘里的视频对应的文件编号。文件以<br/>        编号.mp4命名。如001.mp4,002.mp4</li>    <li>播放协议    <ul><li>常规： 播放普通的视频文件</li>    <li>实时监控： 播放局域网下监控摄像头的实时画面</li>    </ul></li>  <li>机顶盒编号: 用于指定播放本段视频的机顶盒。</li>  <li>视频长度: 播放文件时，用于指定需要播放的时长(应小于文件本身的时长)。</li>  <li>播放地址: 网络模式下，在服务器的视频路径。如完整路径为：<br/>http://192.168.1.100/HYZG/videos/001.mp4  此处应填写001.mp4</li>  ',
        hc_dt_14 : '<h3>计数器</h3><br/>  <p><li>存放数值，可以用于数值计算和判定<br/></li></p>  <p><li>秒级计时器，可以用于秒级的计时<br/></li></p>',
        hc_dt_2 : '<h3>机顶盒、打印机等</h3><br/>  <p><li>搜寻模式<ul><li>自动发现：通过内部设备发现协议，可以自动发现主板所属主题的网络设备</li><br/>  <li>指定IP端口：配置网络设备的IP和端口</li>  </li></p>',
        hc_dt_3 : '<h3>主控板的单个输入端口</h3><br/>  <p><li>工作模式<ul><li>普通：端口有有效电平时触发</li><br/>  <li>按键按下：按键按下时，触发一次</li><br/>  <li>按键释放：按键释放时，触发一次</li><br/>  <li>触发计数：端口被触发指定次数时，触发一次</li><br/>  <li>按下持续时间：端口被持续触发指定的时长后，触发一次</li><br/>  <li>松开持续时间：端口持续未被触发指定的时长后，触发一次</li><br/>  <li>反向信号：端口没有有效电平时触发，一般用于检测输出电磁锁信号的机关</li><br/>  <li>流程复位：按键按下时，流程复位</li><br/>  </li></p>',
        hc_dt_4 : '<h3>主控板的单个输出端口</h3><br/>  <p><li>工作模式<ul><li>普通：开 继电器导通，关 继电器断开</li><br/>  <li>循环：启动后，继电器工作指定的次数。每个循环中，导通和断开时间通过<br/>“开启时长”和“关闭时长”配置，次数由“计数”配置<br/>  执行完成后，结束的状态可以是开(继电器导通)或关(继电器断开)，由“结束状态”配置</li><br/>  <li>预设亮度：仅V5硬件有效，开 按照预设值输出PWM，关 彻底断开</li><br/>  <li>渐亮渐灭：仅V5硬件有效，开 从0开始逐步增加至预设值，变化时长由“开启时长”控制<br/>关 从预设值逐步减小至彻底断开。变化时长由“关闭时长”控制</li><br/>  <li>随机闪烁：仅V5硬件PWM板有效，开 随机亮度变化，变化快慢由“开启时长”控制，熄灭时长由“关闭时长”控制<br/>关 立即熄灭</li><br/>  <li>呼吸效果：仅V5硬件PWM板有效，开 均匀亮度变化，变化快慢由“开启时长”控制<br/>关 立即熄灭</li><br/>  <li>状态跟随：开 跟随输入端口的状态，输入端口号由“计数”指定<br/>关 停止跟随状态</li><br/>  </li></p>',
        hc_dt_5 : '<h3>各种类型的门</h3><br/>  <p><li>工作模式<ul><li>电磁锁(常开)：电磁锁接在常开端，由“开门端口”控制。关门状态 端口继电器导通</li><br/>  <li>闭门器：由“开门端口”控制。关门状态 端口继电器导通</li><br/>  <li>推杆电机：由“开门端口”和“关门端口”控制。    <br/>关门状态 关门端口继电器导通“关延时”秒(如果延时为0，一直保持导通)    <br/>开门状态 开门端口继电器导通“开延时”秒(如果延时为0，一直保持导通)</li><br/>  <li>电磁锁(常闭)：电磁锁接在常闭端，由“开门端口”控制。关门状态 端口继电器断开</li><br/>  <li>闭门器带电磁锁：闭门器由“开门端口”控制。关门状态 端口继电器断开<br/>  电磁锁 由“关门端口”控制。关门状态 端口继电器导通</li><br/>  </li></p>',
        hc_dt_7 : '<h3>灯设备</h3><br/>  <p><li>端口号<ul><li>灯的供电由“端口”控制。灯点亮时，对应端口的继电器导通</li><br/>  </li></p>',
        hc_dt_8 : '<h3>音效</h3><br/>  <span>音效支持本地模式(U盘或TF卡)和网络模式(通过音效机顶盒)</span>  <p><li>文件编号<ul><li>音效对应的文件编号，文件在U盘或服务器上以编号.mp3命名。<br/>  如001.mp3,002.mp3</li><br/>  </li></p>  <p><li>机顶盒编号<ul><li>用于指定播放本音效的机顶盒。</li><br/>  </li></p>',
        mn_dt_1_p10 : [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            111,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            124,
            125,
            126,
            127,
            128
        ],
        mn_dt_1_p8 : [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            111,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            124,
            125,
            126,
            127,
            128
        ],
        dh_ip_w10_count_b0_0 : '绑定的计数器',
        dh_ip_w11_count_b0_0 : '绑定的计数器',
        dh_ip_w2_count_b0_0 : '绑定的计数器',
        dh_ip_w3_count_b0_0 : '按下多少次之后触发',
        dh_ip_w4_count_b0_0 : '按下多少次之后触发',
        dn_ip_w0_device_io_b0_0 : '端口号',
        dn_ip_w1_device_io_b0_0 : '端口号',
        dn_ip_w10_count_b0_0 : '计数器',
        dn_ip_w10_device_io_b0_0 : '端口号',
        dn_ip_w11_count_b0_0 : '计数器',
        dn_ip_w11_device_io_b0_0 : '端口号',
        dn_ip_w2_count_b0_0 : '计数器',
        dn_ip_w2_device_io_b0_0 : '端口号',
        dn_ip_w3_count_b0_0 : '按下次数',
        dn_ip_w3_device_io_b0_0 : '端口号',
        dn_ip_w4_count_b0_0 : '按下次数',
        dn_ip_w4_device_io_b0_0 : '端口号',
        dn_ip_w4_interval_b0_0 : '限时(秒)',
        dn_ip_w5_device_io_b0_0 : '端口号',
        dn_ip_w5_interval_b0_0 : '限时(秒)',
        dn_ip_w6_device_io_b0_0 : '端口号',
        dn_ip_w6_interval_b0_0 : '限时(秒)',
        dn_ip_w7_device_io_b0_0 : '端口号',
        dn_ip_w7_interval_b0_0 : '限时(秒)',
        dn_ip_w8_device_io_b0_0 : '端口号',
        dn_ip_w9_device_io_b0_0 : '端口号',
        wm_ip_w0 : '普通',
        wm_ip_w1 : '按键按下',
        wm_ip_w10 : '多卡识别',
        wm_ip_w11 : '遥控接收',
        wm_ip_w2 : '按键释放',
        wm_ip_w3 : '触发计数',
        wm_ip_w4 : '触发计数（限时）',
        wm_ip_w5 : '按下持续时间',
        wm_ip_w6 : '松开持续时间',
        wm_ip_w7 : '间断按下持续时间',
        wm_ip_w8 : '反向信号',
        wm_ip_w9 : '流程复位',
        at_iog_w10_result_io_b12_12 : 'はい',
        at_iog_w2_ck_io_b0_2 : '单次输出',
        at_iog_w2_ck_io_b3_3 : '开启',
        at_iog_w2_result_io_b0_0 : '亮起后保持',
        dh_iog_w0_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w0_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w1_fail_wait_b0_0 : '如果失败，重启等待的时间（冷却时间）',
        dh_iog_w1_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w1_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w1_start_io_b0_2 : '0 普通, 1 单按键，2 反向信号',
        dh_iog_w1_start_io_b13_13 : '去除重复按键',
        dh_iog_w1_start_io_b14_15 : '0 不开启；1 输出端口有效时，按键有效；2 输出端口无效时，按键有效',
        dh_iog_w1_start_io_b3_5 : '0 无灯, 1 按下亮，2按下亮保持，3 按下灭，4 按下灭保持，5 按下亮保持（不自动亮），6按下灭保持（不自动亮）',
        dh_iog_w1_start_io_b6_6 : '不等按完全部按键，随时进行判定，遇错输出',
        dh_iog_w1_start_io_b8_12 : '0 全部判定，1-16 只判定前1-16个按键',
        dh_iog_w10_ck_io_b0_7 : '成功回数を記録するカウンター。0 なし、1～255 カウンター番号',
        dh_iog_w10_input_io_list_b0_0 : '按键的端口号',
        dh_iog_w10_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w10_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w10_output_io_list_b0_0 : '按键上灯的端口号',
        dh_iog_w10_result_io_b11_11 : '失败后输出错误信息，并停止当前这一轮',
        dh_iog_w10_result_io_b12_12 : 'ミス時に減点するか。0 いいえ、1 はい',
        dh_iog_w10_start_io_b0_0 : '成功数量是否累计，如果不累计，过关需要连续成功',
        dh_iog_w10_start_io_b1_5 : '过关的成功次数（最大31）',
        dh_iog_w10_start_io_b12_15 : '每次出题亮灯的数量，0 随机，1-15 数量上限',
        dh_iog_w10_start_io_b6_11 : '数值越大难度越低，最大60',
        dh_iog_w10_stop_io_b0_4 : '单次错误后闪灯，0 不闪烁，1-30闪烁次数',
        dh_iog_w11_input_io_list_b0_0 : '按键的端口号',
        dh_iog_w11_output_io_list_b0_0 : '按键上灯的端口号',
        dh_iog_w11_result_io_b8_15 : '失败重启间隔秒数',
        dh_iog_w11_start_io_b0_5 : '需要记忆的最大数量',
        dh_iog_w11_start_io_b11_15 : '谜题之间灭灯时长（0.1-3秒）',
        dh_iog_w11_start_io_b6_10 : '每个谜题亮灯时长（0.1-3秒）',
        dh_iog_w11_stop_io_b0_10 : '答题最长时间限制 1-100秒',
        dh_iog_w11_stop_io_b11_13 : '答题时按键是否跟随亮灯',
        dh_iog_w11_stop_io_b14_14 : '遇到错误立即结束本轮，并输出失败',
        dh_iog_w12_ck_io_b6_10 : '灯的最大亮度，1-100',
        dh_iog_w12_fail_wait_b0_15 : '呼吸的速度，值越大呼吸越慢',
        dh_iog_w12_output_io_list_b0_0 : '灯的端口号',
        dh_iog_w12_result_io_b11_15 : '停在最亮、最暗的时间',
        dh_iog_w13_fail_wait_b0_0 : '如果失败，重启等待的时间（冷却时间）',
        dh_iog_w13_input_io_list_b0_0 : 'IC感应器所接的输入端口（只能1个）',
        dh_iog_w13_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w13_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w13_output_io_list_b0_0 : '答案卡号列表',
        dh_iog_w13_start_io_b13_13 : '是否去除重复卡号（每一轮）',
        dh_iog_w13_start_io_b3_5 : '0 顺序模式, 1 循环模式',
        dh_iog_w13_start_io_b6_6 : '不等按完全部按键，随时进行判定，遇错输出（仅顺序模式）',
        dh_iog_w13_start_io_b8_12 : '0 全部判定，1-16 只判定前1-16个答案（仅顺序模式）',
        dh_iog_w14_ck_io_b0_5 : '编码器累计多少脉冲之后，数值变化一次',
        dh_iog_w14_input_io_list_b0_0 : '感应器所接的输入端口（只能2个）',
        dh_iog_w14_output_io_list_b0_0 : '在输出端口输出当前对应的数值',
        dh_iog_w14_result_io_b0_7 : '0 不绑定，其余数值  计数器索引号',
        dh_iog_w14_result_io_b8_15 : '当数值调整到这个值的时候，判定结果为成功',
        dh_iog_w14_start_io_b0_2 : '0 直接输出, 1 8421码',
        dh_iog_w14_start_io_b3_4 : '数值调整到头后，会自动循环到另外一端开始',
        dh_iog_w14_start_io_b5_6 : '0 正向安装，1 反向安装',
        dh_iog_w14_stop_io_b0_7 : '当数值调整到这个值的时候，判定结果为成功',
        dh_iog_w15_input_io_list_b0_0 : '如果配置了输入端口，会从输入端口读取到数值并输出',
        dh_iog_w15_output_io_list_b0_0 : '在输出端口输出当前对应的数值',
        dh_iog_w15_result_io_b0_7 : '0 不绑定，其余数值  计数器索引号',
        dh_iog_w15_result_io_b8_15 : '当数值调整到这个值的时候，判定结果为成功',
        dh_iog_w15_start_io_b0_2 : '0 直接输出, 1 8421码, 2 连续端口段',
        dh_iog_w15_start_io_b3_5 : '输入端口读取的模式，0 单个端口有效, 1 8421码',
        dh_iog_w2_fail_wait_b0_0 : '循环的间隔时间',
        dh_iog_w2_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w2_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w2_start_io_b0_0 : '端口点亮的时长',
        dh_iog_w2_stop_io_b0_0 : '端口熄灭后亮下一个的时长',
        dh_iog_w3_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w3_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w4_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w4_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w5_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w5_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w6_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w6_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w7_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w7_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w7_start_io_b0_2 : '0 普通, 1 单按键，2 反向信号',
        dh_iog_w8_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w8_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w8_start_io_b6_8 : '0 无序，只判定数量；1 有序，错误自动重启；2 有序，错误立即输出',
        dh_iog_w9_input_io_list_b0_0 : '只填一个',
        dh_iog_w9_on_fail_ae_b0_0 : '失败时，自动播放的音效编号。0 不播放',
        dh_iog_w9_on_success_ae_b0_0 : '成功时，自动播放的音效编号。0 不播放',
        dh_iog_w9_start_io_b0_0 : '连续敲击后的间隔时间，超过该时间后的敲击计为下一段',
        dh_iog_w9_stop_io_b0_0 : '不输出错误信号，直至最终成功为止',
        dn_iog_w0_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w0_fail_wait_b0_0 : '失败等待',
        dn_iog_w0_input_io_count_b0_0 : '输入端口数',
        dn_iog_w0_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w0_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w0_on_success_ae_b0_0 : '成功音效',
        dn_iog_w0_output_io_count_b0_0 : '输出端口数',
        dn_iog_w0_output_io_list_b0_0 : '输出端口列表',
        dn_iog_w0_result_io_b1_5 : '结果端口（信号1）',
        dn_iog_w0_start_io_b0_0 : '启动端口',
        dn_iog_w0_stop_io_b0_0 : '停止端口',
        dn_iog_w1_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w1_fail_wait_b0_0 : '失败等待',
        dn_iog_w1_input_io_count_b0_0 : '输入端口数',
        dn_iog_w1_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w1_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w1_on_success_ae_b0_0 : '成功音效',
        dn_iog_w1_output_io_count_b0_0 : '输出端口数',
        dn_iog_w1_output_io_list_b0_0 : '输出端口列表',
        dn_iog_w1_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w1_start_io_b0_2 : '按键模式',
        dn_iog_w1_start_io_b13_13 : '去除重复',
        dn_iog_w1_start_io_b14_15 : '输出绑定',
        dn_iog_w1_start_io_b3_5 : '按键亮灯模式',
        dn_iog_w1_start_io_b6_6 : '持续判定',
        dn_iog_w1_start_io_b8_12 : '部分判定',
        dn_iog_w1_stop_io_b0_0 : '输入端口列表',
        dn_iog_w10_ck_io_b0_7 : '成功カウンター',
        dn_iog_w10_fail_wait_b0_0 : '自动重启时间',
        dn_iog_w10_input_io_count_b0_0 : '输入端口数',
        dn_iog_w10_input_io_list_b0_0 : '按键端口',
        dn_iog_w10_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w10_on_success_ae_b0_0 : '成功音效',
        dn_iog_w10_output_io_count_b0_0 : '按键灯数量',
        dn_iog_w10_output_io_list_b0_0 : '按键灯端口',
        dn_iog_w10_result_io_b10_10 : '指定亮灯数量',
        dn_iog_w10_result_io_b11_11 : '错误即停止',
        dn_iog_w10_result_io_b12_12 : 'ミス時に減点',
        dn_iog_w10_start_io_b0_0 : '成功累计',
        dn_iog_w10_start_io_b1_5 : '过关成功次数',
        dn_iog_w10_start_io_b12_15 : '每题亮灯数量',
        dn_iog_w10_start_io_b6_11 : '难度系数',
        dn_iog_w10_stop_io_b0_4 : '错误后闪灯',
        dn_iog_w10_stop_io_b11_15 : '重启间隔',
        dn_iog_w10_stop_io_b5_9 : '错误闪灯间隔',
        dn_iog_w11_input_io_count_b0_0 : '输入端口数',
        dn_iog_w11_input_io_list_b0_0 : '按键端口',
        dn_iog_w11_output_io_count_b0_0 : '按键灯数量',
        dn_iog_w11_output_io_list_b0_0 : '按键灯端口',
        dn_iog_w11_result_io_b8_15 : '重启间隔',
        dn_iog_w11_start_io_b0_5 : '谜题数量',
        dn_iog_w11_start_io_b11_15 : '灭灯时长',
        dn_iog_w11_start_io_b6_10 : '亮灯时长',
        dn_iog_w11_stop_io_b0_10 : '答题时限',
        dn_iog_w11_stop_io_b11_13 : '答题按键灯',
        dn_iog_w11_stop_io_b14_14 : '错误立即输出',
        dn_iog_w12_ck_io_b6_10 : '最大亮度',
        dn_iog_w12_fail_wait_b0_15 : '呼吸速度',
        dn_iog_w12_output_io_count_b0_0 : '按键灯数量',
        dn_iog_w12_output_io_list_b0_0 : '灯端口',
        dn_iog_w12_result_io_b11_15 : '停留时间',
        dn_iog_w13_fail_wait_b0_0 : '失败等待',
        dn_iog_w13_input_io_count_b0_0 : '输入端口数',
        dn_iog_w13_input_io_list_b0_0 : '输入端口',
        dn_iog_w13_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w13_on_success_ae_b0_0 : '成功音效',
        dn_iog_w13_output_io_count_b0_0 : '答案数',
        dn_iog_w13_output_io_list_b0_0 : '答案列表',
        dn_iog_w13_start_io_b13_13 : '去除重复',
        dn_iog_w13_start_io_b3_5 : '判定模式',
        dn_iog_w13_start_io_b6_6 : '顺序模式持续判定',
        dn_iog_w13_start_io_b8_12 : '顺序模式部分判定',
        dn_iog_w14_ck_io_b0_5 : '每档脉冲数量',
        dn_iog_w14_input_io_count_b0_0 : '输入端口数',
        dn_iog_w14_input_io_list_b0_0 : '输入端口',
        dn_iog_w14_output_io_count_b0_0 : '输出端口数',
        dn_iog_w14_output_io_list_b0_0 : '输出端口',
        dn_iog_w14_result_io_b0_7 : '绑定计数器',
        dn_iog_w14_result_io_b8_15 : '预期结果',
        dn_iog_w14_start_io_b0_2 : '结果输出模式',
        dn_iog_w14_start_io_b3_4 : '循环调节',
        dn_iog_w14_start_io_b5_6 : '感应器方向',
        dn_iog_w14_stop_io_b0_7 : '数值上限',
        dn_iog_w15_input_io_count_b0_0 : '输入端口数',
        dn_iog_w15_input_io_list_b0_0 : '输入端口',
        dn_iog_w15_output_io_count_b0_0 : '输出端口数',
        dn_iog_w15_output_io_list_b0_0 : '输出端口',
        dn_iog_w15_result_io_b0_7 : '绑定计数器',
        dn_iog_w15_result_io_b8_15 : '预期结果',
        dn_iog_w15_start_io_b0_2 : '结果输出模式',
        dn_iog_w15_start_io_b3_5 : '输入模式',
        dn_iog_w2_ck_io_b0_2 : '是否单次输出',
        dn_iog_w2_ck_io_b3_3 : '随机顺序',
        dn_iog_w2_fail_wait_b0_0 : '循环间隔',
        dn_iog_w2_input_io_count_b0_0 : '输入端口数',
        dn_iog_w2_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w2_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w2_on_success_ae_b0_0 : '成功音效',
        dn_iog_w2_output_io_count_b0_0 : '输出端口数',
        dn_iog_w2_output_io_list_b0_0 : '输出端口列表',
        dn_iog_w2_result_io_b0_0 : '是否保持点亮',
        dn_iog_w2_start_io_b0_0 : '点亮时间',
        dn_iog_w2_stop_io_b0_0 : '熄灭时间',
        dn_iog_w3_input_io_count_b0_0 : '输入端口数',
        dn_iog_w3_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w3_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w3_on_success_ae_b0_0 : '成功音效',
        dn_iog_w3_output_io_count_b0_0 : '节拍数量',
        dn_iog_w3_output_io_list_b0_0 : '节拍列表',
        dn_iog_w3_result_io_b0_8 : '整体间隔',
        dn_iog_w3_start_io_b0_12 : '端口',
        dn_iog_w3_start_io_b14_14 : '循环播放',
        dn_iog_w3_stop_io_b0_4 : '点亮时间',
        dn_iog_w3_stop_io_b10_15 : '节拍间隔',
        dn_iog_w3_stop_io_b5_9 : '熄灭时间',
        dn_iog_w4_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w4_fail_wait_b0_0 : '失败等待',
        dn_iog_w4_input_io_count_b0_0 : '输入端口数',
        dn_iog_w4_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w4_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w4_on_success_ae_b0_0 : '成功音效',
        dn_iog_w4_output_io_count_b0_0 : '输出端口数',
        dn_iog_w4_output_io_list_b0_0 : '输出端口列表',
        dn_iog_w4_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w4_start_io_b0_0 : '启动端口',
        dn_iog_w4_stop_io_b0_0 : '停止端口',
        dn_iog_w5_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w5_fail_wait_b0_0 : '失败等待',
        dn_iog_w5_input_io_count_b0_0 : '输入端口数',
        dn_iog_w5_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w5_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w5_on_success_ae_b0_0 : '成功音效',
        dn_iog_w5_output_io_count_b0_0 : '输出端口数',
        dn_iog_w5_output_io_list_b0_0 : '输出端口列表',
        dn_iog_w5_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w5_start_io_b0_0 : '启动端口',
        dn_iog_w5_stop_io_b0_0 : '停止端口',
        dn_iog_w6_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w6_fail_wait_b0_0 : '失败等待',
        dn_iog_w6_input_io_count_b0_0 : '输入端口数',
        dn_iog_w6_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w6_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w6_on_success_ae_b0_0 : '成功音效',
        dn_iog_w6_output_io_count_b0_0 : '输出端口数',
        dn_iog_w6_output_io_list_b0_0 : '输出端口列表',
        dn_iog_w6_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w6_start_io_b0_0 : '启动端口',
        dn_iog_w6_stop_io_b0_0 : '停止端口',
        dn_iog_w7_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w7_fail_wait_b0_0 : '失败等待',
        dn_iog_w7_input_io_count_b0_0 : '输入端口数',
        dn_iog_w7_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w7_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w7_on_success_ae_b0_0 : '成功音效',
        dn_iog_w7_output_io_count_b0_0 : '结果数量',
        dn_iog_w7_output_io_list_b0_0 : '结果列表',
        dn_iog_w7_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w7_start_io_b0_2 : '按键模式',
        dn_iog_w7_stop_io_b0_0 : '停止端口',
        dn_iog_w8_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w8_fail_wait_b0_0 : '失败等待',
        dn_iog_w8_input_io_count_b0_0 : '输入端口数',
        dn_iog_w8_input_io_list_b0_0 : '输入端口列表',
        dn_iog_w8_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w8_on_success_ae_b0_0 : '成功音效',
        dn_iog_w8_output_io_count_b0_0 : '结果数量',
        dn_iog_w8_output_io_list_b0_0 : '结果列表',
        dn_iog_w8_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w8_start_io_b6_8 : '判定模式',
        dn_iog_w8_stop_io_b0_0 : '停止端口',
        dn_iog_w9_ck_io_b0_0 : '触发端口（信号2）',
        dn_iog_w9_fail_wait_b0_0 : '自动重启时间',
        dn_iog_w9_input_io_count_b0_0 : '输入端口数',
        dn_iog_w9_input_io_list_b0_0 : '输入端口',
        dn_iog_w9_on_fail_ae_b0_0 : '失败音效',
        dn_iog_w9_on_success_ae_b0_0 : '成功音效',
        dn_iog_w9_output_io_count_b0_0 : '节奏组数量',
        dn_iog_w9_output_io_list_b0_0 : '节奏组列表',
        dn_iog_w9_result_io_b0_0 : '结果端口（信号1）',
        dn_iog_w9_start_io_b0_0 : '节奏段间隔',
        dn_iog_w9_stop_io_b0_0 : '持续判定',
        ec_iog_w1_input_io_list : '端口编辑',
        ec_iog_w1_output_io_list : '端口编辑',
        ec_iog_w1_stop_io : '端口编辑',
        ec_iog_w10_input_io_list : '按键端口编辑',
        ec_iog_w10_output_io_list : '灯端口编辑',
        ec_iog_w11_input_io_list : '按键端口编辑',
        ec_iog_w11_output_io_list : '灯端口编辑',
        ec_iog_w12_output_io_list : '灯端口编辑',
        ec_iog_w13_input_io_list : '端口编辑',
        ec_iog_w13_output_io_list : '端口编辑',
        ec_iog_w14_input_io_list : '端口编辑',
        ec_iog_w14_output_io_list : '端口编辑',
        ec_iog_w15_input_io_list : '端口编辑',
        ec_iog_w15_output_io_list : '端口编辑',
        ec_iog_w2_output_io_list : '端口编辑',
        ec_iog_w5_input_io_list : '端口编辑',
        ec_iog_w6_input_io_list : '端口编辑',
        ec_iog_w7_input_io_list : '端口编辑',
        ec_iog_w7_output_io_list : '端口编辑',
        ec_iog_w8_input_io_list : '端口编辑',
        ec_iog_w8_output_io_list : '结果编辑',
        ec_iog_w9_input_io_list : '端口编辑',
        ec_iog_w9_output_io_list : '结果编辑',
        ec_dt_1_p8 : '端口编辑',
        ei_dt_1_p8 : '端口',
        ev_dt_1_p8 : '端口号',
        ec_dt_1_p10 : '端口编辑',
        ei_dt_1_p10 : '端口',
        ev_dt_1_p10 : '端口号',
        ei_iog_w1_input_io_list : '端口',
        ei_iog_w1_output_io_list : '端口',
        ei_iog_w1_stop_io : '端口',
        ei_iog_w10_input_io_list : '端口',
        ei_iog_w10_output_io_list : '端口',
        ei_iog_w11_input_io_list : '端口',
        ei_iog_w11_output_io_list : '端口',
        ei_iog_w12_output_io_list : '端口',
        ei_iog_w13_input_io_list : '端口',
        ei_iog_w13_output_io_list : '答案',
        ei_iog_w14_input_io_list : '端口',
        ei_iog_w14_output_io_list : '端口',
        ei_iog_w15_input_io_list : '端口',
        ei_iog_w15_output_io_list : '端口',
        ei_iog_w2_output_io_list : '端口',
        ei_iog_w5_input_io_list : '端口',
        ei_iog_w6_input_io_list : '端口',
        ei_iog_w7_input_io_list : '端口',
        ei_iog_w7_output_io_list : '端口',
        ei_iog_w8_input_io_list : '端口',
        ei_iog_w8_output_io_list : '计数',
        ei_iog_w9_input_io_list : '端口',
        ei_iog_w9_output_io_list : '敲击次数',
        ev_iog_w1_input_io_list : '端口号',
        ev_iog_w1_output_io_list : '端口号',
        ev_iog_w1_stop_io : '端口号',
        ev_iog_w10_input_io_list : '端口号',
        ev_iog_w10_output_io_list : '端口号',
        ev_iog_w11_input_io_list : '端口号',
        ev_iog_w11_output_io_list : '端口号',
        ev_iog_w12_output_io_list : '端口号',
        ev_iog_w13_input_io_list : '端口号',
        ev_iog_w13_output_io_list : '答案卡号',
        ev_iog_w14_input_io_list : '端口号',
        ev_iog_w14_output_io_list : '端口号',
        ev_iog_w15_input_io_list : '端口号',
        ev_iog_w15_output_io_list : '端口号',
        ev_iog_w2_output_io_list : '端口号',
        ev_iog_w5_input_io_list : '端口号',
        ev_iog_w6_input_io_list : '端口号',
        ev_iog_w7_input_io_list : '端口号',
        ev_iog_w7_output_io_list : '端口号',
        ev_iog_w8_input_io_list : '端口号',
        ev_iog_w8_output_io_list : '按下次数',
        ev_iog_w9_input_io_list : '端口号',
        ev_iog_w9_output_io_list : '节奏次数',
        it_iog_w10_result_io_b12_12 : 'いいえ',
        it_iog_w2_ck_io_b0_2 : '循环输出',
        it_iog_w2_ck_io_b3_3 : '不开启',
        it_iog_w2_result_io_b0_0 : '熄灭亮下一个',
        wm_iog_w0 : '外接模块',
        wm_iog_w1 : '顺序端口组',
        wm_iog_w10 : '地鼠游戏',
        wm_iog_w11 : '记忆按键',
        wm_iog_w12 : '呼吸灯组',
        wm_iog_w13 : '多卡顺序识别',
        wm_iog_w14 : '旋转编码器',
        wm_iog_w15 : '数字输入输出',
        wm_iog_w2 : '顺序输出',
        wm_iog_w3 : '节拍输出',
        wm_iog_w4 : '输入并联',
        wm_iog_w5 : '输入串联',
        wm_iog_w6 : '无序按键',
        wm_iog_w7 : '循环按键',
        wm_iog_w8 : '循环按键',
        wm_iog_w9 : '节奏判定',
        at_op_w1_finish_status_b0_0 : '开启',
        at_op_w1_ms_ctrl_b0_0 : '毫秒',
        at_op_w2_finish_status_b0_0 : '开启',
        at_op_w4_finish_status_b0_0 : '开启',
        at_op_w6_finish_status_b0_0 : '开启',
        dh_op_w1_count_b0_0 : '达到此次数之后停止循环，并且端口保持XX状态',
        dh_op_w1_ms_ctrl_b0_0 : '控制精度的单位',
        dh_op_w2_count_b0_0 : '达到此次数之后停止循环，并且端口保持XX状态',
        dh_op_w3_brightness_b0_0 : '端口打开之后的亮度值',
        dh_op_w4_brightness_b0_0 : '最亮时候的亮度值',
        dh_op_w4_brightness_low_b0_0 : '最暗时候的亮度值',
        dh_op_w4_interval1_b0_0 : '变亮的时长，值越大变化越慢',
        dh_op_w4_interval2_b0_0 : '变暗的时长，值越大变化越慢',
        dh_op_w5_brightness_b0_0 : '最亮时候的亮度值',
        dh_op_w5_brightness_low_b0_0 : '最暗时候的亮度值',
        dh_op_w5_count_b0_0 : '闪烁时亮起的占比，数值越大，亮的时间越长',
        dh_op_w5_interval1_b0_0 : '亮度变化速度，值越大越慢',
        dh_op_w5_interval2_b0_0 : '熄灭保持的时间，值越大越长',
        dh_op_w6_brightness_b0_0 : '最亮时候的亮度值',
        dh_op_w6_brightness_low_b0_0 : '最暗时候的亮度值',
        dh_op_w6_interval1_b0_0 : '亮度变化速度，值越大越慢',
        dh_op_w6_interval2_b0_0 : '在最亮、最暗保持的时间，值越大越长',
        dh_op_w8_count_b0_0 : '跟随的输入端口号（1-200）',
        dn_op_w0_device_io_b0_0 : '端口号',
        dn_op_w1_count_b0_0 : '循环次数',
        dn_op_w1_device_io_b0_0 : '端口号',
        dn_op_w1_finish_status_b0_0 : '结束状态',
        dn_op_w1_interval1_b0_0 : '开启时长',
        dn_op_w1_interval2_b0_0 : '关闭时长',
        dn_op_w1_ms_ctrl_b0_0 : '毫秒级控制',
        dn_op_w2_count_b0_0 : '循环次数',
        dn_op_w2_device_io_b0_0 : '端口号',
        dn_op_w2_finish_status_b0_0 : '结束状态',
        dn_op_w2_interval1_b0_0 : '开启时长',
        dn_op_w2_interval2_b0_0 : '关闭时长',
        dn_op_w3_brightness_b0_0 : '亮度',
        dn_op_w3_device_io_b0_0 : '端口号',
        dn_op_w4_brightness_b0_0 : '最大亮度',
        dn_op_w4_brightness_low_b0_0 : '最小亮度',
        dn_op_w4_device_io_b0_0 : '端口号',
        dn_op_w4_finish_status_b0_0 : '结束状态',
        dn_op_w4_interval1_b0_0 : '变亮时长',
        dn_op_w4_interval2_b0_0 : '变暗时长',
        dn_op_w5_brightness_b0_0 : '最大亮度',
        dn_op_w5_brightness_low_b0_0 : '最小亮度',
        dn_op_w5_count_b0_0 : '闪烁间隔',
        dn_op_w5_device_io_b0_0 : '端口号',
        dn_op_w5_interval1_b0_0 : '变化速度',
        dn_op_w5_interval2_b0_0 : '熄灭时长',
        dn_op_w6_brightness_b0_0 : '最大亮度',
        dn_op_w6_brightness_low_b0_0 : '最小亮度',
        dn_op_w6_device_io_b0_0 : '端口号',
        dn_op_w6_finish_status_b0_0 : '结束状态',
        dn_op_w6_interval1_b0_0 : '变化速度',
        dn_op_w6_interval2_b0_0 : '保持时间',
        dn_op_w7_device_io_b0_0 : '端口号',
        dn_op_w8_count_b0_0 : '跟随输入端口',
        dn_op_w8_device_io_b0_0 : '端口号',
        it_op_w1_finish_status_b0_0 : '关闭',
        it_op_w1_ms_ctrl_b0_0 : '秒',
        it_op_w2_finish_status_b0_0 : '关闭',
        it_op_w4_finish_status_b0_0 : '关闭',
        it_op_w6_finish_status_b0_0 : '关闭',
        wm_op_w0 : '普通',
        wm_op_w1 : '循环',
        wm_op_w2 : '随机循环',
        wm_op_w3 : '预设亮度',
        wm_op_w4 : '渐亮渐灭',
        wm_op_w5 : '随机闪烁',
        wm_op_w6 : '呼吸效果',
        wm_op_w7 : '保留',
        wm_op_w8 : '状态跟随',
        dh_dt_11_p1 : '???????????U???????????????(????)',

        dn_dt_1 : '???????',
        dn_dt_2 : '????????',
        dn_dt_3 : '?????',
        dn_dt_4 : '?????',
        dn_dt_5 : '??-??/???',
        dn_dt_7 : '??-???',
        dn_dt_8 : '??',
        dn_dt_9 : '????',
        dn_dt_10 : '???',
        dn_dt_11 : '??',
        dn_dt_12 : '??',
        dn_dt_13 : '??????????????',
        dn_dt_14 : '?????',
        dn_dt_30 : '???',
        dn_dt_31 : '????',
        dn_dt_32 : '????',
        dn_dt_33 : '????????????',
        dn_dt_34 : '???????',
        dn_dt_35 : '?????',
        dn_dt_36 : '?????',
        dn_dt_39 : '?????',
        dn_dt_40 : '????',

        dh_dt_11_p2 : '???????????????',
        dh_dt_12_p1 : 'U???????????????',
        dh_dt_1_p1 : '???????: ????????????????: ???????????',
        dh_dt_1_p2 : '',
        dh_dt_1_p3 : '?????????',
        dh_dt_1_p4 : '?????????',
        dh_dt_1_p5 : '???????????1??????????????',
        dn_dt_10_p1 : '??????',
        dn_dt_10_p2 : '????????????',
        dn_dt_10_p3 : '????',
        dn_dt_11_p1 : '??????',
        dn_dt_11_p2 : '???????',
        dn_dt_11_p2_p1 : ['??(FILE/HTTP)', '????????'],
        dn_dt_11_p3 : '????????????',
        dn_dt_11_p4 : '????(?)',
        dn_dt_11_p5 : '??????(?????)',
        dn_dt_11_p6 : '????',
        dn_dt_12_p1 : '????????',
        dn_dt_12_p2 : '????????????',
        dn_dt_12_p3 : '??????(?????)',
        dn_dt_13_p1 : '??????????',
        dn_dt_13_p2 : '????????????',
        dn_dt_14_p1 : '?????',
        dn_dt_14_p2 : '???????????',
        dn_dt_1_p1 : '?????',
        dn_dt_1_p2 : '???????????',
        dn_dt_1_p3 : '?????',
        dn_dt_1_p4 : '?????',
        dn_dt_1_p5 : '?????(??1)',
        dn_dt_1_p6 : '???????(??2)',
        dn_dt_1_p7 : '????',
        dn_dt_1_p8 : '???????',
        dn_dt_1_p9 : '??????',
        dn_dt_1_p10 : '???????',
        dn_dt_1_p11 : '??????',
        dn_dt_1_p12 : '?????',
        dn_dt_1_p13 : '?????',
        dn_dt_2_p1 : '?????',
        dn_dt_2_p2 : '????????ID',
        dn_dt_2_p3 : 'IP????',
        dn_dt_2_p4 : 'IP???',
        dn_dt_3_p1 : '?????',
        dn_dt_3_p2 : '?????',
        dn_dt_3_p3 : '???????????',
        dn_dt_3_p4 : '????',
        dn_dt_3_p5 : '??(?)',
        dn_dt_4_p1 : '?????',
        dn_dt_4_p10 : '????',
        dn_dt_4_p2 : '?????',
        dn_dt_4_p3 : '???????????',
        dn_dt_4_p4 : '????',
        dn_dt_4_p5 : '??(?)',
        dn_dt_4_p6 : '??(?)',
        dn_dt_4_p7 : '?????',
        dn_dt_4_p8 : '????',
        dn_dt_4_p9 : '????',
        dn_dt_5_p1 : '?????',
        dn_dt_5_p2 : '???????????',
        dn_dt_5_p3 : '?????',
        dn_dt_5_p4 : '?????',
        dn_dt_5_p5 : '????(?)',
        dn_dt_7_p1 : '???',
        dn_dt_7_p2 : '??',
        dn_dt_8_p1 : '??????',
        dn_dt_8_p2 : '????????????',
        dn_dt_8_p3 : '????',
        dn_dt_9_p1 : '??????',
        dn_dt_9_p2 : '????????????',
        dn_dt_9_p3 : '????',
        mn_dt_14_p1 : ['??', '????'],
        p98_djcfg_sel_itm_local : 'ローカル',

        p97_devcfg_stn_dt_1 : ['失敗', '成功', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '実行'],
        p97_devcfg_stn_dt_2 : ['オフライン', 'オンライン'],
        p97_devcfg_stn_dt_3 : ['無効', '有効'],
        p97_devcfg_stn_dt_4 : ['閉', '開'],
        p97_devcfg_stn_dt_5 : ['開', '開作動中', '閉作動中', '閉'],
        p97_devcfg_stn_dt_7 : ['閉', '開'],
        p97_devcfg_stn_dt_6 : ['閉', '開'],
        p97_devcfg_stn_dt_8 : ['正常', '正常'],
        p97_devcfg_stn_dt_10 : ['停止', '再生', '再生', '一時停止'],
        p97_devcfg_stn_dt_11 : ['停止', '再生', '再生', '一時停止'],
        p97_devcfg_stn_dt_12 : ['停止', '再生'],
        p97_devcfg_opn_dt_12_op_0 : '停止',
        p97_devcfg_opn_dt_12_op_1 : '再生',
        p97_devcfg_stn_dt_13 : ['停止', '実行'],
        p97_devcfg_stn_dt_14 : ['停止', '実行'],
        p97_devcfg_opn_dt_1_op_0 : '閉',
        p97_devcfg_opn_dt_1_op_1 : '開',
        p97_devcfg_opn_dt_4_op_0 : '閉',
        p97_devcfg_opn_dt_4_op_1 : '開',
        p97_devcfg_opn_dt_5_op_0 : '開',
        p97_devcfg_opn_dt_5_op_1 : '閉',
        p97_devcfg_opn_dt_7_op_0 : '閉',
        p97_devcfg_opn_dt_7_op_1 : '開',
        p97_devcfg_opn_dt_6_op_0 : '閉',
        p97_devcfg_opn_dt_6_op_1 : '開',
        p97_devcfg_opn_dt_8_op_1 : '再生',
        p97_devcfg_opn_dt_10_op_1 : '再生',
        p97_devcfg_opn_dt_10_op_3 : '一時停止',
        p97_devcfg_opn_dt_10_op_2 : '再開',
        p97_devcfg_opn_dt_10_op_0 : '停止',
        p97_devcfg_opn_dt_11_op_1 : '再生',
        p97_devcfg_opn_dt_11_op_2 : '再開',
        p97_devcfg_opn_dt_11_op_3 : '一時停止',
        p97_devcfg_opn_dt_11_op_0 : '停止',
        p97_devcfg_opn_dt_13_op_1 : '開始',
        p97_devcfg_opn_dt_13_op_0 : '停止',
        mn_dt_1_p1 : [
            '???????',
            '????',
            '????',
            '????',
            '????',
            '????',
            '?????',
            '????',
            '????',
            '?????(???)',
            '?????????',
            '????',
            '???????',
            '??????????',
            '????????',
            '???????',
            '???????',
            '????????'
        ],
        mn_dt_2_p1 : ['????', 'IP???????'],
        mn_dt_3_p1 : [
            '??',
            '?????',
            '?????',
            '????????',
            '????????(????)',
            '??????',
            '??????',
            '????????',
            '????',
            '???????',
            '????????',
            '??????'
        ],
        mn_dt_4_p1 : ['??', '???', '???????', '???????', '??????/???????', '??????', '????', '??', '????'],
        mn_dt_4_p2 : ['??', '??'],
        mn_dt_5_p1 : ['???', '???(????)', '???????(??)', '???????', '???(????)', '???????(??)', '???????+???'],
        // Action and condition names shared by the editor and flow exports.
        an_0_1: '開始',
        an_0_0: '停止',
        an_1_1: '開始',
        an_1_0: '停止',
        an_2_1: '開始',
        an_2_0: '停止',
        an_3_1: '開始',
        an_3_0: '停止',
        an_4_1: '開始',
        an_4_0: '停止',
        an_4_2: '明るさ設定',
        an_4_11: '状態反転',
        an_5_0: '解錠',
        an_5_1: '施錠',
        an_5_2: '状態反転',
        an_7_1: '点灯',
        an_7_0: '消灯',
        an_7_2: '明るさ設定',
        an_8_1: '再生',
        an_8_0: '停止',
        an_8_4: '音量設定',
        an_9_0: '停止',
        an_9_1: '再生',
        an_10_1: '再生',
        an_10_0: '停止',
        an_10_2: '再開',
        an_10_3: '一時停止',
        an_10_4: '音量設定',
        an_10_5: '優先再生',
        an_11_1: '再生',
        an_11_0: '停止',
        an_11_2: '再開',
        an_11_3: '一時停止',
        an_11_5: 'ループモード',
        an_12_1: '再生',
        an_12_2: '再開',
        an_12_3: '一時停止',
        an_13_1: '開始',
        an_13_0: '停止',
        an_13_2: '再開',
        an_13_3: '一時停止',
        an_14_0: '停止',
        an_14_1: '開始',
        an_14_2: '値を設定',
        an_14_4: '加算',
        an_14_5: '減算',
        an_14_6: '乗算',
        an_14_7: '除算',
        an_14_10: '乱数生成',
        an_14_12: '加算',
        an_14_13: '減算',
        an_14_14: '乗算',
        an_14_15: '除算',
        an_30_1: '開始',
        an_30_0: '停止',
        an_30_8: 'タイマーリセット',
        an_30_9: '進行リセット',
        an_30_3: '進行スキップ',
        an_31_1: '常に実行',
        an_33_1: 'ネットワーク準備完了',
        an_32_1: 'スキップ',
        an_34_1: '部屋の片付け完了',
        an_35_1: 'テーマ開始',
        an_36_1: 'テーマ終了',
        an_39_1: 'シーン効果トリガー',
        an_40_1: '言語設定',
        an_37_1: '進行リセット',
        an_37_2: '進行一時停止',
        an_37_3: '進行速度を上げる',
        an_37_4: '進行速度を下げる',
        ln_1_true: '成功',
        ln_1_false: '失敗',
        ln_2_true: '成功',
        ln_2_false: '失敗',
        ln_3_true: '有効',
        ln_3_false: '無効',
        ln_3_2: '等しい',
        ln_3_3: 'より大きい',
        ln_3_4: '以上',
        ln_3_5: 'より小さい',
        ln_3_6: '以下',
        ln_3_7: '等しくない',
        ln_4_true: '有効',
        ln_4_false: '無効',
        ln_5_true: '閉',
        ln_5_false: '開',
        ln_6_true: '開',
        ln_6_false: '閉',
        ln_7_true: '点灯中',
        ln_7_false: '消灯中',
        ln_8_true: '再生中',
        ln_8_false: '停止中',
        ln_9_true: '再生中',
        ln_9_false: '停止中',
        ln_10_true: '再生中',
        ln_10_false: '停止中',
        ln_11_true: '再生中',
        ln_11_false: '停止中',
        ln_12_true: '再生中',
        ln_12_false: '停止中',
        ln_13_true: '成功',
        ln_13_false: '失敗',
        ln_13_2: 'イベント受信',
        ln_14_2: '等しい',
        ln_14_3: 'より大きい',
        ln_14_4: '以上',
        ln_14_5: 'より小さい',
        ln_14_6: '以下',
        ln_14_7: '等しくない',
        ln_14_8: '変化',
        ln_31_true: '常に成立',
        ln_33_true: '準備完了',
        p9_zbxx_col_id : 'ID',

    },
    organization,
    themeSceneExport,
    role: {
        permission: '权限',
    },
    user: {

    },
    title: {

    }
}
